__turbopack_context__.v({
  "arc": "_1CyL_q_arc",
  "badge": "_1CyL_q_badge",
  "bump": "_1CyL_q_bump",
  "count": "_1CyL_q_count",
  "disc": "_1CyL_q_disc",
  "lock": "_1CyL_q_lock",
  "mine": "_1CyL_q_mine",
  "neutral": "_1CyL_q_neutral",
  "passive": "_1CyL_q_passive",
  "ring": "_1CyL_q_ring",
  "track": "_1CyL_q_track",
});
